let Widget3dsoft = require('./Main.js');

/**
 * 
 * @returns {undefined}
 */
Widget3dsoft.prototype.showFormVehicule = function (bFormVehiculeUncomplete) {
    if(bFormVehiculeUncomplete == undefined){
        bFormVehiculeUncomplete = false;
    }
    
    if (this.verifStepClientDone()) {
        var self = this;
        
        fCallbackFormVeh = function(self,response){
                    $(self.sClass).html(response);
                    self.filArianne(self, 'stepVehicule');

                    //Autocomplétion de l'immat car peut être renseignée à l'étape accueil
                    $(self.sClass + ' .widget3Dsoft-immatriculation').val(self.rendezvous.sImmatriculation);


                    if (self.rendezvous.iIdClient != undefined && self.rendezvous.iIdClient != null && self.rendezvous.iIdClient != "") {
                        //This client exists, create a select list with his vehicles
                        self.searchVehiculesClient(self, self.rendezvous.iIdClient, function (aVehicules) {

                            self.aVehicules = aVehicules;
                            //Add his vehicle
                            $(self.sClass + ' .widget3Dsoft-vehicule').append('<option value="">' + self.sLanguage.VEHICULE_MSG_NOUVEAU_VEHICULE + '</option>');

                            for (keyVeh in self.aVehicules) {
                                var optionHtml = '';
                                optionHtml += '<option value="' + self.aVehicules[keyVeh]._VEH_ID + '"';

                                if (self.oSearchClient.sImmatriculation != undefined && self.oSearchClient.sImmatriculation == self.aVehicules[keyVeh]._VEH_IMMATRICULATION) {
                                    optionHtml += ' selected ';
                                    self.rendezvous.iIdVehicule = self.aVehicules[keyVeh]._VEH_ID;
                                }
                                optionHtml += '>';

                                optionHtml += self.aVehicules[keyVeh]._VEH_LIBELLE_MODELE + ' ' + self.aVehicules[keyVeh]._VEH_IMMATRICULATION;
                                optionHtml += '</option>';
                                $(self.sClass + ' .widget3Dsoft-vehicule').append(optionHtml);
                            }
                            //Si on est déjà passé par cette étape ou que l'immat a ete trouvee
                            if (self.rendezvous.iIdVehicule) {
                                $(self.sClass + ' .widget3Dsoft-vehicule').val(self.rendezvous.iIdVehicule);
                                self.changeVehicule(self, self.rendezvous.iIdVehicule);
                            }

                            $(self.sClass + ' .divVehicule').show();

                        });

                    }
                    self.searchMarques(self);
                    $(self.sClass + ' .widget3Dsoft-immatriculation').val(self.rendezvous.sImmatriculation);
                    $(self.sClass + ' .widget3Dsoft-vin').val(self.rendezvous.sVin);
                    $(self.sClass + ' .widget3Dsoft-kilometrage').val(self.rendezvous.iKm);

                    var aDate = (self.rendezvous.sDateMec === null) ? [] : self.rendezvous.sDateMec.split('-');                     
                    $(self.sClass + ' .widget3Dsoft-dateMec-JJ').val(aDate[2]);
                    $(self.sClass + ' .widget3Dsoft-dateMec-MM').val(aDate[1]);
                    $(self.sClass + ' .widget3Dsoft-dateMec-AAAA').val(aDate[0]);
                    

                    if (self.updateRdvActif) {
                        $(self.sClass + ' .widget3Dsoft-vehicule').prop('disabled', 'disabled');
                    }

                    $(self.sClass + ' .widget3Dsoft-vehicule').change(function () {
                        self.changeVehicule(self, $(self.sClass + ' .widget3Dsoft-vehicule').val())
                    });

                    $(self.sClass + ' .widget3Dsoft-marque').change(function () {
                        self.changeMarque(self, $(self.sClass + ' .widget3Dsoft-marque').val());
                    });

                    $(self.sClass + ' .widget3Dsoft-modele').change(function () {
                        self.changeModele(self, $(self.sClass + ' .widget3Dsoft-modele').val());
                    });


                    if(!self.oSite.bIdentifierVehicule){
                        $(self.sClass + ' .widget3Dsoft-modeleLibelle').change(function () {
                            self.changeModele(self, $(self.sClass + ' .widget3Dsoft-modele').val());
                        });
                        
                        $(self.sClass + ' .widget3Dsoft-marqueLibelle ').change(function () {
                            self.changeMarque(self, $(self.sClass + ' .widget3Dsoft-marque').val());
                        });
                    }

                    if(bFormVehiculeUncomplete){
                       $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.INTERVENTIONS_STEP_VEHICULE_MUST_BE_COMPLETE);
                       $(self.sClass + ' .widget3Dsoft-message').show();
                    }
                    self.completeFooter();
                    self.adaptDimensions(self);
                    self.headerProfil(self);


                    $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').click(function () {
                        self.validerVehicule(self);
                    });    
        }
        
        //if we have the html in cache we use it
        if(self.sHtmlFormVehicule){
            fCallbackFormVeh(self,self.sHtmlFormVehicule);
        }else{
            self.ajax('GET',
                self.sServerURL + 'widget/form-vehicule' + self.sParamsGet,
                {},
                function (response) {
                    self.sHtmlFormVehicule = response;
                    fCallbackFormVeh(self,response);
                });
        }
    }
};


Widget3dsoft.prototype.searchMarques = function (self) {

    self.ajax('POST',
            self.sServerURL + 'rest/vehicule/marques' + self.sParamsGet,
            {},
            function (response) {

                if (bIEOld3Dsoft) {
                    response = JSON.parse(response);
                }

                $(self.sClass + ' .widget3Dsoft-loading').hide();
                if (response.success === true) {

                    self.aMarques = [];
                    $.each(response.datas.aMarques, function (iIdMarque, oMarque) {
                        self.aMarques[iIdMarque] = oMarque;
                    });

                    $(self.sClass + ' .widget3Dsoft-marque').append($('<option>', {
                        value: '',
                        text: ''
                    }));

                    $.each(response.datas.aMarques, function (key, oMarque) {
                        $(self.sClass + ' .widget3Dsoft-marque').append($('<option>', {
                            value: key,
                            text: oMarque.libelle
                        }));
                    });

                    //Si on a deja renseigne la marque on la selectionne et on fait de meme pour le modele
                    if (self.rendezvous.iIdMarque !== null) {
                        $(self.sClass + ' .widget3Dsoft-marque').val(self.rendezvous.iIdMarque);

                        if (self.aModeles.length > 0) {
                            $(self.sClass + ' .widget3Dsoft-modele').append($('<option>', {
                                value: '',
                                text: ''
                            }));

                            for (iIdModele in self.aModeles) {
                                $(self.sClass + ' .widget3Dsoft-modele').append($('<option>', {
                                    value: iIdModele,
                                    text: self.aModeles[iIdModele].libelle
                                }));
                            }

                            if (self.rendezvous.iIdModele !== null) {
                                $(self.sClass + ' .widget3Dsoft-modele').val(self.rendezvous.iIdModele);
                                $(self.sClass + ' .widget3Dsoft-modele-empty').hide();
                                $(self.sClass + ' .widget3Dsoft-modele').show();
                                $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').removeAttr('disabled');
                            }
                        }
                    }
                }
            },true);
}

/**
 * 
 * @param widget3Dsoft self
 * @param {type} iIdClient
 * @returns {undefined}
 */
Widget3dsoft.prototype.searchVehiculesClient = function (self, iIdClient, callback) {

    self.ajax('POST',
            self.sServerURL + 'rest/vehicule/by-client' + self.sParamsGet,
            {iIdClient: iIdClient},
    function (response) {
        if (bIEOld3Dsoft) {
            response = JSON.parse(response);
        }
        if (typeof (callback) == 'function') {
            callback(response.datas.aVehicules);
        }
    },true);
}

/**
 * 
 * @param widget3Dsoft self
 * @param {type} iIdVehicule
 * @returns {undefined}
 */
Widget3dsoft.prototype.changeVehicule = function (self, iIdVehicule) {
    //Si vide => nouveau client donc on affiche les champs ou nouveau vÃ©hicule
    
    if (iIdVehicule == '' || iIdVehicule == undefined || iIdVehicule == null) {

        self.rendezvous.iIdVehicule = null;

        //Immat
        $(self.sClass + ' .widget3Dsoft-immatriculation').show();
        $(self.sClass + ' .widget3Dsoft-divVehImmatriculation').hide();

        //Vin
        $(self.sClass + ' .widget3Dsoft-vin').show();
        $(self.sClass + ' .widget3Dsoft-divVehVin').hide();

        //Marque
        $(self.sClass + ' .widget3Dsoft-marque').show();
        $(self.sClass + ' .widget3Dsoft-divVehSelectedMarque').hide();

        //Modele
        $(self.sClass + ' .widget3Dsoft-divSelectModele').show();
        $(self.sClass + ' .widget3Dsoft-divVehSelectedModele').hide();

        //Kilometrage
        $(self.sClass + ' .widget3Dsoft-kilometrage').show();
        $(self.sClass + ' .widget3Dsoft-divKilometrage').hide();

        //Date MEC
        $(self.sClass + ' .widget3Dsoft-dateMec').show();
        $(self.sClass + ' .widget3Dsoft-divDateMec').hide();

        $(self.sClass + ' .widget3Dsoft-btnUpdateVehicule').hide();

        if ($(self.sClass + ' .widget3Dsoft-modele').val() === undefined || $(self.sClass + ' .widget3Dsoft-modele').val() === '') {
            $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').attr('disabled', 'disabled');
        }

    } else {
        //this.aVehicules

        //Immat
        //$(self.sClass + ' .widget3Dsoft-immatriculation').hide();
        //$(self.sClass + ' .widget3Dsoft-divVehImmatriculation').html(self.aVehicules[iIdVehicule]._VEH_IMMATRICULATION);
        //$(self.sClass + ' .widget3Dsoft-divVehImmatriculation').show();
        $(self.sClass + ' .widget3Dsoft-immatriculation').val(self.aVehicules[iIdVehicule]._VEH_IMMATRICULATION);

        //Vin
        //$(self.sClass + ' .widget3Dsoft-vin').hide();
        //$(self.sClass + ' .widget3Dsoft-divVehVin').html(self.aVehicules[iIdVehicule]._VEH_NO_SERIE);
        //$(self.sClass + ' .widget3Dsoft-divVehVin').show();
        $(self.sClass + ' .widget3Dsoft-vin').val(self.aVehicules[iIdVehicule]._VEH_NO_SERIE);

        //Marque
        if (self.aVehicules[iIdVehicule]._MAR_ID != null) {
            $(self.sClass + ' .widget3Dsoft-marque').hide();
            $(self.sClass + ' .widget3Dsoft-divVehSelectedMarque').html(self.aVehicules[iIdVehicule]._VEH_LIBELLE_MARQUE);
            $(self.sClass + ' .widget3Dsoft-divVehSelectedMarque').show();
            self.rendezvous.iIdMarque = self.aVehicules[iIdVehicule]._MAR_ID;

            //Modele
            $(self.sClass + ' .widget3Dsoft-divSelectModele').hide();
            $(self.sClass + ' .widget3Dsoft-divVehSelectedModele').html(self.aVehicules[iIdVehicule]._VEH_LIBELLE_MODELE);
            $(self.sClass + ' .widget3Dsoft-divVehSelectedModele').show();
            self.rendezvous.iIdModele = self.aVehicules[iIdVehicule]._MOD_ID;
        } else {
            $(self.sClass + ' .widget3Dsoft-marque').show();
            $(self.sClass + ' .widget3Dsoft-divVehSelectedMarque').hide();
        }

        //Kilometrage
        //$(self.sClass + ' .widget3Dsoft-kilometrage').hide();
        //$(self.sClass + ' .widget3Dsoft-divKilometrage').html(self.aVehicules[iIdVehicule]._VEH_KILOMETRAGE);
        //$(self.sClass + ' .widget3Dsoft-divKilometrage').show();
        $(self.sClass + ' .widget3Dsoft-kilometrage').val(self.aVehicules[iIdVehicule]._VEH_KILOMETRAGE);

        //Date MEC
        if (self.aVehicules[iIdVehicule]._VEH_DATE_MEC != '' && self.aVehicules[iIdVehicule]._VEH_DATE_MEC != null) 
        {
        	var myDate = self.aVehicules[iIdVehicule]._VEH_DATE_MEC.split("-");
            $(self.sClass + ' .widget3Dsoft-dateMec-AAAA').val(myDate[0]);
            $(self.sClass + ' .widget3Dsoft-dateMec-MM').val(myDate[1]);
            $(self.sClass + ' .widget3Dsoft-dateMec-JJ').val(myDate[2]);
        }
        
        $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').removeAttr('disabled');
        $(self.sClass + ' .widget3Dsoft-btnUpdateVehicule').show();

    }
};

/**
 * 
 * @returns {undefined}
 */
Widget3dsoft.prototype.changeMarque = function () {
    var self = this;
    $(self.sClass + ' .widget3Dsoft-modele').empty();
    $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').attr('disabled', 'disabled');

    var iIdMarque = $(self.sClass + ' .widget3Dsoft-marque').val();
    if (self.oSite.bIdentifierVehicule && (iIdMarque == undefined || iIdMarque === '')) {
        $(self.sClass + ' .widget3Dsoft-modele-empty').show();
        $(self.sClass + ' .widget3Dsoft-modele').hide();
        
    } else if (!self.oSite.bIdentifierVehicule) {
            self.rendezvous.sMarqueLibelle = $(self.sClass + ' .widget3Dsoft-marqueLibelle ').val();
            self.checkBtnValidationCanBeAllowed(self);
    } else {

        //$(self.sClass + ' .widget3Dsoft-modele').empty();
            self.rendezvous.iIdMarque = iIdMarque;
            $(self.sClass + ' .widget3Dsoft-loading').show();

            self.ajax('POST',
                    self.sServerURL + 'rest/vehicule/modeles' + self.sParamsGet,
                    {
                        iIdMarque: iIdMarque
                    },
            function (response) {

                if (bIEOld3Dsoft) {
                    response = JSON.parse(response);
                }

                $(self.sClass + ' .widget3Dsoft-loading').hide();
                if (response.success === true) {

                    self.aModeles = [];
                    $.each(response.datas.aModeles, function (iIdModele, oModele) {
                        self.aModeles[iIdModele] = oModele;
                    });

                    $(self.sClass + ' .widget3Dsoft-modele').append($('<option>', {
                        value: '',
                        text: ''
                    }));

                    for (iIdModele in self.aModeles) {
                        $(self.sClass + ' .widget3Dsoft-modele').append($('<option>', {
                            value: iIdModele,
                            text: self.aModeles[iIdModele].libelle
                        }));
                    }
                }

                //Show modele select and hide modele-empty
                $(self.sClass + ' .widget3Dsoft-modele-empty').hide();
                $(self.sClass + ' .widget3Dsoft-modele').show();
            },true);
    }
}

/**
 * 
 * @returns {undefined}
 */
Widget3dsoft.prototype.changeModele = function () {
    var self = this;
    
    if(!self.oSite.bIdentifierVehicule){
        self.rendezvous.sModeleLibelle = $(self.sClass + ' .widget3Dsoft-modeleLibelle ').val();
    }else{
        self.rendezvous.iIdModele = $(self.sClass + ' .widget3Dsoft-modele').val();
    }
    
    self.checkBtnValidationCanBeAllowed(self);
    
};

/**
 * if the form is valid the user can validate it, we allow to press dthe btn (remove attr "disabled")
 * else the btn stay "disabled"
 * @returns {undefined}
 */
Widget3dsoft.prototype.checkBtnValidationCanBeAllowed = function(self){
    
    if(     !self.oSite.bIdentifierVehicule 
        && $(self.sClass + ' .widget3Dsoft-marqueLibelle').val() != '' 
        && $(self.sClass + ' .widget3Dsoft-marqueLibelle').val() != undefined
        && $(self.sClass + ' .widget3Dsoft-modeleLibelle').val() != '' 
        && $(self.sClass + ' .widget3Dsoft-modeleLibelle').val() != undefined){
         $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').removeAttr('disabled');
        
    }else if(   $(self.sClass + ' .widget3Dsoft-modele').val() != undefined 
             && $(self.sClass + ' .widget3Dsoft-modele').val() != ''){
        //it's not sit_veh_identifier and a modele is selected
        $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').removeAttr('disabled');
        
    }else{
        $(self.sClass + ' .widget3Dsoft-btnValiderVehicule').attr('disabled', 'disabled');
    }
};

/**
 * We update the vehicule if it's a new Client
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.validerVehicule = function (self) {
    $(self.sClass + ' .widget3Dsoft-loading').show();

    if ($(self.sClass + ' .widget3Dsoft-vehicule').val() == null || $(self.sClass + ' .widget3Dsoft-vehicule').val() == '') {

        //Nouveau vehicule
        self.rendezvous.sImmatriculation = $(self.sClass + ' .widget3Dsoft-immatriculation').val();
        self.rendezvous.sVin = $(self.sClass + ' .widget3Dsoft-vin').val();
        self.rendezvous.iIdMarque = $(self.sClass + ' .widget3Dsoft-marque').val();
        self.rendezvous.iIdModele = $(self.sClass + ' .widget3Dsoft-modele').val();
        self.rendezvous.iKm = $(self.sClass + ' .widget3Dsoft-kilometrage').val();

        var sDateMec = '';
        if ($(self.sClass + ' .widget3Dsoft-dateMec-AAAA').val() !== ''
                || $(self.sClass + ' .widget3Dsoft-dateMec-MM').val() !== ''
                || $(self.sClass + ' .widget3Dsoft-dateMec-JJ').val() !== '') {
            sDateMec = String($(self.sClass + ' .widget3Dsoft-dateMec-AAAA').val()) + '-';
            sDateMec += String($(self.sClass + ' .widget3Dsoft-dateMec-MM').val()) + '-';
            sDateMec += String($(self.sClass + ' .widget3Dsoft-dateMec-JJ').val());
        }

        if (self.isDate(sDateMec) || sDateMec === '') {
            self.rendezvous.sDateMec = sDateMec;
            $(self.sClass + ' .widget3Dsoft-loading').hide();
            self.showFormInterventions();
        } else {
            $(self.sClass + ' .widget3Dsoft-dateMec-AAAA').addClass('error');
            $(self.sClass + ' .widget3Dsoft-dateMec-MM').addClass('error');
            $(self.sClass + ' .widget3Dsoft-dateMec-JJ').addClass('error');
            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VEHICULE_MSG_DATE_MEC_MAUVAIS_FORMAT);
            $(self.sClass + ' .widget3Dsoft-loading').hide();
            $(self.sClass + ' .widget3Dsoft-message').show();
        }
    } else {

        //Vehicule existant
        self.rendezvous.iIdVehicule = $(self.sClass + ' .widget3Dsoft-vehicule').val();

        if (self.aVehicules[self.rendezvous.iIdVehicule]._MAR_ID !== null) {
            self.rendezvous.iIdMarque = self.aVehicules[self.rendezvous.iIdVehicule]._MAR_ID;
        } else {
            self.rendezvous.iIdMarque = $(self.sClass + ' .widget3Dsoft-marque').val();
        }

        if (self.aVehicules[self.rendezvous.iIdVehicule]._MOD_ID !== null) {
            self.rendezvous.iIdModele = self.aVehicules[self.rendezvous.iIdVehicule]._MOD_ID;
        } else {
            self.rendezvous.iIdModele = $(self.sClass + ' .widget3Dsoft-modele').val();
        }

        self.rendezvous.sImmatriculation = $(self.sClass + ' .widget3Dsoft-immatriculation').val();
        self.rendezvous.sVin = $(self.sClass + ' .widget3Dsoft-vin').val();
        self.rendezvous.iKm = $(self.sClass + ' .widget3Dsoft-kilometrage').val();
        this.updateVehicule(function () {
            self.showFormInterventions();
        });

    }

};

Widget3dsoft.prototype.updateVehicule = function (callback) {
    var self = this;
    $(self.sClass + ' .widget3Dsoft-message').hide();
    $(self.sClass + ' .widget3Dsoft-loading').show();
    //var self = this; utile ?

    self.ajax('POST',
            self.sServerURL + 'rest/vehicule/update' + self.sParamsGet,
            {
                iIdVehicule: $(self.sClass + ' .widget3Dsoft-vehicule').val(),
                sImmatriculation: $(self.sClass + ' .widget3Dsoft-immatriculation').val(),
                sVin: $(self.sClass + ' .widget3Dsoft-vin').val(),
                iKm: $(self.sClass + ' .widget3Dsoft-kilometrage').val(),
                iIdMarque: $(self.sClass + ' .widget3Dsoft-marque').val(),
                iIdModele: $(self.sClass + ' .widget3Dsoft-modele').val(),
                sModeleLibelle: self.rendezvous.sModeleLibelle,
                sMarqueLibelle: self.rendezvous.sMarqueLibelle
            },
    function (response) {
        $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VEHICULE_MSG_UPDATE_SUCCESS);
        $(self.sClass + ' .widget3Dsoft-message').show();
        if (typeof (callback) == 'function') {
            callback();
        }
    },true);

}
